(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/game-card-body-selfservice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/game-card-body-selfservice.js');

'use strict';

const {
  AndraChansenRowBanner
} = svs.numbergames.ReactAndraChansen;
const {
  isLotto,
  isKeno
} = svs.numbergames.productMapping;
const {
  CampaignInfo
} = svs.gamePackage.components;
const GameCardBodySelfService = _ref => {
  let {
    game,
    draw,
    campaignInfo
  } = _ref;
  const {
    productId,
    productItsId,
    boards,
    drawCount,
    hasJoker,
    hasLotto2
  } = game;
  return React.createElement("div", null, isLotto(productId) && hasJoker && React.createElement(AndraChansenRowBanner, {
    shouldShowIcon: true,
    lottoDraws: [{
      productId: productItsId,
      drawNumber: draw.drawNumber
    }],
    wager: {
      rowCount: boards.length,
      numberOfDays: 1,
      drawCount,
      hasJoker,
      hasLotto2
    }
  }), isKeno(productId) && campaignInfo && React.createElement(CampaignInfo, {
    campaignInfo: campaignInfo,
    productItsId: productItsId
  }));
};
svs.gamePackage.components.GameCardBodySelfService = GameCardBodySelfService;

 })(window);